import React from 'react'
import {getMultiplierAndTimeInterval} from '../MaxBookingDuration/utils';
import { I18n, Translate } from "react-redux-i18n";

export default function BookingLimitationInfo({circle}) {
    const max_bookings = circle.max_active_bookings_per_member>0? circle.max_active_bookings_per_member : I18n.t('new_circle.unlimited');
    const {time_interval_multiplier, time_interval} = getMultiplierAndTimeInterval(circle.max_booking_duration_in_minutes);
    const max_duration = time_interval_multiplier>0? `${time_interval_multiplier} ${I18n.t(`${time_interval}${time_interval_multiplier>1?'s':''}`)}` : I18n.t('new_circle.unlimited')
    
    return (
        <div className="booking-calendar-limitations">
            <div className="limitation-item">
                <strong><Translate value="new_circle.labels.max_active_bookings" /></strong>
                <span className="limitation-value">{max_bookings}</span>
            </div>
            <div className="limitation-item">
                <strong><Translate value="new_circle.labels.max_booking_duration" /></strong>
                <span className="limitation-value">{max_duration}</span>
            </div>
        </div>
    )
}
